import React from "react";
import "./styles.css";
import StatsData from "../../assets/images/StatsData.png";
const Stats = (DataDashboard) => {
  console.log("dashboard//stats//DataDashboard",DataDashboard?.DataDashboard);
  console.log("dashboard//stats//events",DataDashboard?.DataDashboard?.events?.e);
  return (
    <div className="mainStatsDiv">
      <div className="StatsDiv">
        <div className="StatsHeading">
          <img src={StatsData} alt="stats icon" />
          <h3>Today’s Stats</h3>
        </div>
      </div>
      <div className="StatsData">
        <div
          className="StatsItem"
          style={{ borderBottom: "1px solid #F2F2F2", padding: ".9rem .5rem" }}
        >
          <div>
            <p>Students Enrolled</p>
          </div>
          <div className="value">
            {/* <h6 className="Green">(+2.1k)</h6> */}
            <h4>{DataDashboard?.DataDashboard?.todayStats?.enrolled}</h4>
          </div>
        </div>
        <div
          className="StatsItem"
          style={{ borderBottom: "1px solid #F2F2F2", padding: ".9rem .5rem" }}
        >
          <div>
            <p>Registrations</p>
          </div>
          <div className="value">
            {/* <h6 className="Green">(+2.1k)</h6> */}
            <h4>{DataDashboard?.DataDashboard?.todayStats?.registration}</h4>
          </div>
        </div>
        <div
          className="StatsItem"
          style={{ borderBottom: "1px solid #F2F2F2", padding: ".9rem .5rem" }}
        >
          <div>
            <p>Visitors</p>
          </div>
          <div className="value">
            {/* <h6 className="Green">(+2.1k)</h6> */}
            <h4>{DataDashboard?.DataDashboard?.todayStats?.visitors}</h4>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Stats;
